import { render, staticRenderFns } from "./CurrentAppointments.vue?vue&type=template&id=cd83dd28&"
import script from "./CurrentAppointments.vue?vue&type=script&lang=js&"
export * from "./CurrentAppointments.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAppointments.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
